// Generated by LiveScript 1.6.0
var ref$, id, log, findInside, Controllers;
ref$ = require('utils'), id = ref$.id, log = ref$.log, findInside = ref$.findInside;
Controllers = {
  'global': require('./global'),
  'home': require('./home'),
  'multi-servd': require('./multi-servd')
};
exports.initAllWithin = function(subdom){
  var i$, ref$, len$, el, lresult$, j$, ref1$, len1$, type, results$ = [];
  for (i$ = 0, len$ = (ref$ = subdom.querySelectorAll('[data-controller]')).length; i$ < len$; ++i$) {
    el = ref$[i$];
    lresult$ = [];
    for (j$ = 0, len1$ = (ref1$ = el.dataset.controller.split(' ')).length; j$ < len1$; ++j$) {
      type = ref1$[j$];
      if (Controllers[type] != null) {
        lresult$.push(Controllers[type]($(el), findInside(el)));
      } else if (type !== '') {
        lresult$.push(console.warn('No such controller:', type));
      }
    }
    results$.push(lresult$);
  }
  return results$;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmxzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsSUFBQSxHQUEyQixPQUEzQixDQUFtQyxPQUFBLENBQW5DLEVBQUUsRUFBdUIsQ0FBQSxDQUFBLENBQXpCLElBQUEsQ0FBQSxFQUFBLEVBQU0sR0FBbUIsQ0FBQSxDQUFBLENBQXpCLElBQUEsQ0FBQSxHQUFBLEVBQVcsVUFBYyxDQUFBLENBQUEsQ0FBekIsSUFBQSxDQUFBO0FBR0EsV0FBWSxDQUFBLENBQUEsQ0FDVjtFQUFBLFVBQWUsUUFBUSxVQUFBO0VBQ3ZCLFFBQWUsUUFBUSxRQUFBO0VBQ3ZCLGVBQWUsUUFBUSxlQUFBO0FBRnZCO0FBS0YsT0FBTyxDQUFDLGFBQWdCLENBQUEsQ0FBQSxDQUFFLFFBQUEsQ0FBQSxNQUFBOztFQUN4QixpR0FBQTtJQUFJOztJQUNGLHdGQUFBO01BQUk7TUFDRixJQUFHLFdBQVcsQ0FBQyxJQUFELENBQVgsUUFBSDtzQkFDRSxXQUFXLENBQUMsSUFBRCxFQUFPLEVBQUUsRUFBRCxHQUFNLFdBQVcsRUFBRCxDQUFsQjtPQUNuQixNQUFBLElBQVEsSUFBSyxDQUFBLEdBQUEsQ0FBSyxFQUFsQjtzQkFDRSxPQUFPLENBQUMsS0FBSyx1QkFBdUIsSUFBeEIiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==

